export default __webpack_public_path__ + "static/media/To-do.20079e68.png";